import { useContext } from "react";
import NavigationContext from "../contexts/NavigationProvider";

const useCustomNavigation = () => {
  return useContext(NavigationContext);
};

export default useCustomNavigation;
